import { render } from "./DeleteUser.vue?vue&type=template&id=b0eb0ab6&scoped=true&ts=true&lang=pug"
import script from "./DeleteUser.vue?vue&type=script&lang=ts"
export * from "./DeleteUser.vue?vue&type=script&lang=ts"

import "./DeleteUser.vue?vue&type=style&index=0&id=b0eb0ab6&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0eb0ab6"]])

export default __exports__